module.exports = __webpack_public_path__ + "static/media/photo138.45c619df.jpg";